import {Formik} from "formik";
import React, {Fragment, useEffect, useMemo, useState} from "react";
import * as Yup from "yup";
import moment from 'moment';
import {cloneDeep, pickBy} from "lodash";

function ScheduleLocationTab({locationPatch, mergeIntoLocationPatch, setFormIsInvalid, combinedLocationServicesMap}) {

  const scheduleTabLocationFields = [
    "name",
    "scheduled"
  ];

  const MS_PER_MINUTE = 60000;

  const earliestDate = new Date(Date.now() - 30 * MS_PER_MINUTE)

  const existingName = (locationPatch.name !== undefined) ? locationPatch.name: ""
  const existingDate = (locationPatch.scheduled !== undefined) ? moment(locationPatch.scheduled).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
  const existingTime = (locationPatch.scheduled !== undefined) ? moment(locationPatch.scheduled).format('HH:mm') : moment().format('HH:mm')

  const [formErrors, setFormErrors] = useState({});

  // only load once or this will cause validation to break
  const initialValues = useMemo(() => ({
    name: existingName,
    scheduleDate: existingDate,
    scheduleTime: existingTime
  }), []);

  function generateDate() {
    const date = document.getElementById("scheduleTime").value
    const time = document.getElementById("scheduleDate").value
    return new Date( date + " " +  time)
  }

  const ScheduleValidation = Yup.object().shape({
    name: Yup.string()
      .max(256, 'Schedule Name must be 256 characters or less.')
      .required('This field is required'),
    scheduleDate: Yup.date()
      .test('dateTimeValidator', 'Scheduled date must not have passed', function(value) {
        return generateDate() > earliestDate
      }),
     scheduleTime: Yup.string()
       .test('dateTimeValidator', 'Scheduled time and date are too far in the past.', function(value) {
         return generateDate() > earliestDate
       })
  })

  const locationFields = {};
  scheduleTabLocationFields.forEach(field => {
      locationFields[field] = locationPatch[field];
  });

  const handleFormUpdate = (formValues, touched, errors) => {
    setFormErrors(errors);
    // Don't allow navigation to other tabs if there are form errors like missing required fields
    const formIsValid = isFormValid(errors);
    setFormIsInvalid(!formIsValid);

    const submitValues = {
      "name": formValues['name'],
      "scheduled": generateDate()
    }

    mergeIntoLocationPatch(submitValues);
  }

  const isFormValid = (formErrors) => {
    const formErrorsCopy = {...formErrors};
    return Object.keys(formErrorsCopy).length === 0
  };

  return <div className="card-spacer-top card-spacer-bottom">
    <Formik initialValues={initialValues}
      validateOnMount={true}
      validationSchema={ScheduleValidation}>
      {({
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
      }) => {
        useEffect(() => {
          handleFormUpdate(values, touched, errors);
        }, [JSON.stringify([values, touched, errors])]);
        return <Fragment>
          <table className="card-spacer-top" style={{"width": "50%"}}>
            <tbody>
              <tr>
                <td>
                  <label htmlFor="name" style={{display: "block"}}>
                    Schedule Name*
                  </label>
                </td>
                <td>
                  <input
                    id="name"
                    placeholder="Schedule Name"
                    type="text"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={"form-control text-input"}
                  />
                </td>
              </tr>
              <tr>
                <td/>
                <td>
                  {errors.name && (touched.name) ?
                    <div className="invalid-feedback"
                      style={{"display": "block"}}>{errors.name}</div> :
                    <div className="invalid-feedback" style={{"display": "block", opacity: "0"}}>line
                      spacer</div>}
                </td>
              </tr>

              <tr>
                <td>
                  <label htmlFor="time" style={{display: "block"}}>
                    Time
                  </label>
                </td>
                <td>
                  <input id="scheduleTime" className="form-control" value={values.scheduleTime} style={{"width": "100%"}} type="time" onChange={handleChange} onBlur={handleBlur}/>
                </td>
              </tr>
              <tr>
                <td/>
                <td>
                  {errors.scheduleTime && touched.scheduleTime ?
                    <div className="invalid-feedback" style={{"display": "block"}}>{errors.scheduleTime}</div> :
                    <div className="invalid-feedback" style={{"display": "block", opacity: "0"}}>line spacer</div>
                  }
                </td>
              </tr>

              <tr>
                <td>
                  <label htmlFor="date" style={{display: "block"}}>
                    Date
                  </label>
                </td>
                <td>
                  <input id="scheduleDate" className="form-control" type="date" value={values.scheduleDate} min={Date.now()} onChange={handleChange} onBlur={handleBlur}/>
                </td>
              </tr>
              <tr>
                <td/>
                <td>
                  {errors.scheduleDate && touched.scheduleDate ?
                    <div className="invalid-feedback" style={{"display": "block"}}>{errors.scheduleDate}</div> :
                    <div className="invalid-feedback" style={{"display": "block", opacity: "0"}}>line spacer</div>
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </Fragment>
      }}
    </Formik>
</div>
}
export default ScheduleLocationTab

